
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Button } from '@/components/ui/button';
import { GripVertical } from 'lucide-react';

export function SortableSectionItem({ id, children }: { id: string, children: React.ReactNode }) {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });
    const style = { transform: CSS.Transform.toString(transform), transition };

    return (
        <div ref={setNodeRef} style={style} {...attributes} className="flex items-center gap-2 bg-gray-50 p-2 rounded-md border text-sm">
            <Button variant="ghost" size="sm" {...listeners} className="cursor-grab active:cursor-grabbing p-1 h-auto">
                <GripVertical className="h-5 w-5 text-gray-400" />
            </Button>
            <div className="flex-grow">{children}</div>
        </div>
    );
}
